var global = window;
var SYMBOL_LIB = '_qha';
var document = global.document;
var location = global.location;

var isFunction = function (param) {
  return typeof param === 'function'
};

var init = function (domainId) {
  global[SYMBOL_LIB] = isFunction(global[SYMBOL_LIB]) ? global[SYMBOL_LIB] : function () {
    global[SYMBOL_LIB].c = global[SYMBOL_LIB].c || [];
    global[SYMBOL_LIB].c.push(arguments);
  };

  global[SYMBOL_LIB].s = 1;

  var protocol = location.protocol === 'https:' ? location.protocol : 'http:';
  var script = document.createElement('script');
  script.defer = true;
  script.async = true;
  script.src = protocol + "//s.union.360.cn/" + domainId + ".js";

  var first = document.getElementsByTagName('script')[0];
  first.parentNode.insertBefore(script, first);
};

// send data
var collect = function (url) {
  global[SYMBOL_LIB]('set', 'page', url);
  global[SYMBOL_LIB]('send', 'pageview');
};

var index = function (router, domainId) {
  if (!router) {
    throw new TypeError('Invalid parameter `router`: ' + router)
  }

  var isIdValid = Number(domainId) > 0;

  if (isIdValid === false) {
    throw new TypeError('Invalid parameter `domainId`: ' + domainId)
  }

  if (isFunction(router)) {
    init(domainId);
    return router(collect)
  }

  if (isFunction(router.afterEach)) {
    init(domainId);
    return router.afterEach(function (to) { return collect(to.fullPath); })
  }

  throw new TypeError('\nParameter `router` is invalid.\n A VueRouter instance or function is required.')
};

export default index;



//////////////////
// WEBPACK FOOTER
// ./~/vue-fx/dist/index.esm.js
// module id = 619
// module chunks = 2